import { useEffect, useState, RefObject } from "react";
import { Icon } from "../../components";
import { IconProps } from "./Icon";
import { MaterialSymbolType } from "./IconConstant";

interface HoverableIconProps {
  defaultIcon: MaterialSymbolType;
  hoverIcon: MaterialSymbolType;
  targetRef: RefObject<HTMLElement | null>;
  size?: number;
  color?: string;
  filled?: boolean;
  onClick?: () => void;
  "data-test"?: string;
}

const HoverableIcon = ({
  defaultIcon,
  hoverIcon,
  targetRef,
  size,
  color,
  filled,
  onClick,
  "data-test": dataTest,
  ...restProps
}: HoverableIconProps & Omit<IconProps, "icon">) => {
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const targetElement = targetRef.current;
    if (!targetElement) return;

    const handleMouseEnter = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);

    targetElement.addEventListener("mouseenter", handleMouseEnter);
    targetElement.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      targetElement.removeEventListener("mouseenter", handleMouseEnter);
      targetElement.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [targetRef]);

  return (
    <Icon
      icon={isHovered ? hoverIcon : defaultIcon}
      size={size}
      color={color}
      filled={filled}
      onClick={onClick}
      data-test={dataTest}
      {...restProps}
    />
  );
};

export default HoverableIcon;
